var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLogout = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "currentColor",
  viewBox: "0 0 280 280"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M197.248 44.595c10.523 0 19.08 8.567 19.08 19.081v152.648c0 10.523-8.557 19.081-19.08 19.081H92.302c-10.523 0-19.08-8.558-19.08-19.081v-28.622h19.08v28.622h104.946V63.676H92.302v28.622h-19.08V63.676c0-10.514 8.557-19.081 19.08-19.081zm-60.043 50.488 44.916 44.831-44.907 44.984-13.51-13.472 21.849-21.886H63.676v-19.08h81.962l-21.914-21.867z"
})));
export default SvgLogout;